





















import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface UserData {
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<UserData>({
      errors: [],
    });


    /******************************
     * methods
     ******************************/
    
    /**
     * 戻る処理
     */
    const goBack = (): void => {
        context.root.$router.go(-1);
    };

    const download = async (): Promise<void> => {
        window.location.href = `/api/teacher/teacher_excel_upload/download`;
    }

    /**
     * アップロード処理
     */
    const upload = async (file: File): Promise<void> => {

      const formData = new FormData();
      formData.append(`file[xlsx]`, file);

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      const methodName = context.root.$store.getters.isOptionSchoolSubjectActive ? "upload_school_subject" : "upload";

      await http.post(`/api/teacher/teacher_excel_upload/${methodName}`, formData).then(response => {
        alert(`アップロードが完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * created
     ******************************/

    /******************************
     * watch
     ******************************/

    return {
      ...toRefs(state),
      goBack,
      download,
      upload,
    };
  },
})
